document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('bm-picker-modal');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
    console.log('Modal moved to body to ensure proper z-index stacking');
  }
  
  const openBtn = document.getElementById('bm-open-picker-btn');
  const closeBtn = document.getElementById('bm-close-modal');
  const grid = document.getElementById('bm-colors-grid');
  const searchInput = document.getElementById('bm-search-input');
  const familyButtonsContainer = document.getElementById('bm-family-buttons');
  const colorCountEl = document.getElementById('bm-color-count');
  const paginationEl = document.getElementById('bm-pagination');
  
  const selectedSwatch = document.getElementById('bm-selected-swatch');
  const selectedName = document.getElementById('bm-selected-name');
  const hiddenInput = document.getElementById('bm-paint-color-input');
  
  let allColors = [];
  let filteredColors = [];
  let families = new Set();
  let isLoaded = false;
  let currentFamily = '';
  let currentSeries = ''; // '', 'preview', 'classics'
  let currentPage = 1;
  const ITEMS_PER_PAGE = 48; // 6 rows × 8 cols

  // Detect series based on code format
  // Classics: pure numbers (001-1680)
  // Preview: numbers with dash (2000-10 to 2175-70)
  function getColorSeries(code) {
    if (!code) return 'other';
    // Preview series: contains dash and starts with 2xxx
    if (code.includes('-') && /^2\d{3}-/.test(code)) {
      return 'preview';
    }
    // Classics series: pure numbers (possibly with leading zeros)
    if (/^\d+$/.test(code)) {
      return 'classics';
    }
    return 'other';
  }

  // Open Modal
  openBtn.addEventListener('click', function() {
    modal.classList.add('open');
    // Data will already be loading or loaded from page load
  });

  // Close Modal
  closeBtn.addEventListener('click', function() {
    modal.classList.remove('open');
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.classList.remove('open');
    }
  });

  // Setup Color variant listener if product has Color variant
  // Setup Color variant listener
  function setupColorVariantListener() {
    console.log('[BM Picker] Setting up variant listeners...');
    
    // 1. Initial Check
    checkCurrentVariant();
    
    // 2. Subscribe to Shopify PubSub (Theme Standard)
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      console.log('[BM Picker] Subscribing to PUB_SUB_EVENTS.variantChange');
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        console.log('[BM Picker] Variant changed (PubSub):', event);
        if (event.data && event.data.variant) {
          handleVariantChange(event.data.variant);
        }
      });
    } else {
      console.warn('[BM Picker] PUB_SUB_EVENTS not available, falling back to legacy polling');
      // Fallback polling if PubSub is missing
      setInterval(checkCurrentVariant, 500);
    }

    // 3. Also listen for URL changes (popstate) as a backup
    window.addEventListener('popstate', () => {
      setTimeout(checkCurrentVariant, 100);
    });
  }

  function handleVariantChange(variant) {
    if (!variant) return;
    
    // Check if any option or the title contains "Tintable" or "Custom"
    const isTintable = isVariantTintable(variant);
    togglePicker(isTintable, variant.title);
  }

  function checkCurrentVariant() {
    // Try to get current variant from form input
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const variantId = variantInput.value;
      // We might not have the full variant object here, so we check the UI state
      // Find the selected radio button for Color
      const selectedColorInput = document.querySelector('input[name*="Color"][type="radio"]:checked') || 
                               document.querySelector('input[name*="color"][type="radio"]:checked');
      
      if (selectedColorInput) {
        const value = selectedColorInput.value;
        const isTintable = value.toLowerCase().includes('tintable') || 
                          value.toLowerCase().includes('custom');
        togglePicker(isTintable, value);
      }
    }
  }

  function isVariantTintable(variant) {
    const keywords = ['tintable', 'custom'];
    const check = (str) => str && keywords.some(k => str.toLowerCase().includes(k));
    
    return check(variant.title) || 
           check(variant.option1) || 
           check(variant.option2) || 
           check(variant.option3);
  }

  function togglePicker(show, variantName) {
    const pickerContainer = document.querySelector('.benjamin-moore-color-picker-container');
    if (!pickerContainer) return;

    const hiddenInput = document.getElementById('bm-paint-color-input');
    const selectedName = document.getElementById('bm-selected-name');
    const selectedSwatch = document.getElementById('bm-selected-swatch');
    
    const computedDisplay = window.getComputedStyle(pickerContainer).display;
    const isShowing = computedDisplay !== 'none';
    
    if (show && !isShowing) {
      pickerContainer.style.display = 'block';
      pickerContainer.classList.add('tintable-mode');
      if (hiddenInput) hiddenInput.setAttribute('required', 'required');
      console.log('[BM Picker] SHOWING picker for:', variantName);
    } else if (!show && isShowing) {
      pickerContainer.style.display = 'none';
      pickerContainer.classList.remove('tintable-mode');
      if (hiddenInput) {
        hiddenInput.removeAttribute('required');
        hiddenInput.value = '';
      }
      if (selectedName) selectedName.textContent = 'No color selected';
      if (selectedSwatch) selectedSwatch.style.backgroundColor = '#ffffff';
      console.log('[BM Picker] HIDING picker for:', variantName);
    }
  }





  // GraphQL Configuration
  const STOREFRONT_API_TOKEN = '6350a25f484c872c580b9f30d80e7fb8';
  const SHOP_DOMAIN = window.location.hostname;
  const GRAPHQL_ENDPOINT = `https://${SHOP_DOMAIN}/api/2024-01/graphql.json`;

  // Load Colors from GraphQL API
  async function loadColors() {
    try {
      grid.innerHTML = '<div class="bm-loading">Loading colors...</div>';
      
      allColors = [];
      let hasNextPage = true;
      let cursor = null;
      let pageCount = 0;
      let isFirstPageRendered = false;
      
      // Fetch all pages using GraphQL cursor-based pagination
      while (hasNextPage) {
        pageCount++;
        // console.log(`Fetching page ${pageCount} from GraphQL...`);
        
        const query = `
          query GetPaintColors($after: String) {
            metaobjects(type: "paint_color", first: 250, after: $after) {
              edges {
                node {
                  fields {
                    key
                    value
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `;
        
        const variables = cursor ? { after: cursor } : {};
        
        const response = await fetch(GRAPHQL_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
          },
          body: JSON.stringify({ query, variables })
        });
        
        if (!response.ok) {
          throw new Error(`GraphQL request failed: ${response.status} ${response.statusText}`);
        }
        
        const result = await response.json();
        
        if (result.errors) {
          throw new Error(`GraphQL errors: ${JSON.stringify(result.errors)}`);
        }
        
        const metaobjects = result.data.metaobjects;
        
        // Process each metaobject
        metaobjects.edges.forEach(edge => {
          const fields = edge.node.fields;
          const color = {};
          
          fields.forEach(field => {
            color[field.key] = field.value;
          });
          
          allColors.push(color);
        });
        
        // console.log(`Loaded ${metaobjects.edges.length} colors, total: ${allColors.length}`);
        
        // Update display every ~500 colors (every other fetch) for smoother experience
        const shouldUpdate = allColors.length >= ITEMS_PER_PAGE && 
                            (pageCount === 1 || pageCount % 2 === 1);
        
        if (shouldUpdate) {
          // Extract families from current data
          families.clear();
          allColors.forEach(color => {
            if (color.family) {
              families.add(color.family);
            }
          });
          
          // Update family buttons and colors
          if (!isFirstPageRendered) {
            console.log(`✓ First render with ${allColors.length} colors`);
            isFirstPageRendered = true;
            isLoaded = true;
          } else {
            // console.log(`✓ Progressive update: ${allColors.length} colors loaded`);
          }
          
          renderFamilyButtons();
          renderColors(allColors);
        }
        
        hasNextPage = metaobjects.pageInfo.hasNextPage;
        cursor = metaobjects.pageInfo.endCursor;
      }
      
      console.log(`✓ Finished loading all ${allColors.length} colors from GraphQL`);
      
      if (allColors.length === 0) {
        grid.innerHTML = '<div class="bm-loading">No colors available in metaobjects.</div>';
        return;
      }
      
      // Final update to ensure we have ALL colors displayed
      families.clear();
      allColors.forEach(color => {
        if (color.family) {
          families.add(color.family);
        }
      });
      
      console.log(`Found ${families.size} unique families (final)`);
      console.log(`✓ Final update with all ${allColors.length} colors`);
      renderFamilyButtons();
      renderColors(allColors);
      
      isLoaded = true;
      window.BenjaminMooreColors = window.BenjaminMooreColors || {};
      window.BenjaminMooreColors.colors = allColors;
      window.BenjaminMooreColors.loaded = true;
    } catch (error) {
      console.error('Error loading colors:', error);
      grid.innerHTML = '<div class="bm-loading">Error loading colors: ' + error.message + '<br><br>Please check that Storefront API token is configured correctly.</div>';
    }
  }

  // Family colors mapping (RGB converted to hex)
  const familyColors = {
    'Black': '#222222',
    'Blue': '#1e40af',
    'Brown': '#5c3310',
    'Gray': '#4b5563',
    'Green': '#047857',
    'Neutral': '#a58d75',
    'Orange': '#b45309',
    'Pink': '#be185d',
    'Purple': '#6d28d9',
    'Red': '#b91c1c',
    'White': '#f3f4f6',
    'Yellow': '#ffcf30'
  };

  function selectFamily(family) {
    currentFamily = family;
    
    // Update button states
    document.querySelectorAll('.bm-family-btn').forEach(btn => {
      if (btn.dataset.family === family) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    
    filterColors();
  }

  // Calculate contrast and determine text color
  function getContrastColor(hexColor) {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    
    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black for light colors, white for dark colors
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  function renderColors(colors) {
    filteredColors = colors;
    currentPage = 1; // Reset to first page
    
    renderPage();
    renderPagination();
  }
  
  function renderPage() {
    grid.innerHTML = '';
    
    // Update color count
    if (colorCountEl) {
      colorCountEl.textContent = `Found ${filteredColors.length} color${filteredColors.length !== 1 ? 's' : ''}`;
    }
    
    if (filteredColors.length === 0) {
      grid.innerHTML = '<div class="bm-loading">No colors found matching your criteria.</div>';
      paginationEl.innerHTML = '';
      return;
    }
    
    // Calculate pagination
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, filteredColors.length);
    const pageColors = filteredColors.slice(startIndex, endIndex);
    
    const fragment = document.createDocumentFragment();

    pageColors.forEach(color => {
      const item = document.createElement('div');
      item.className = 'bm-color-item';
      item.dataset.name = color.name;
      item.dataset.code = color.code;
      item.dataset.hex = color.hex;
      
      const textColor = getContrastColor(color.hex);
      item.innerHTML = `
        <div class="bm-color-preview" style="background-color: ${color.hex}; color: ${textColor};">
          <div class="bm-color-info">
            <span class="bm-color-code">${color.code}</span>
            <span class="bm-color-name">${color.name}</span>
          </div>
        </div>
      `;
      
      const pickerContainer = document.querySelector('.benjamin-moore-color-picker-container');
      const isBrowseMode = pickerContainer && pickerContainer.dataset.mode === 'browse';

      if (!isBrowseMode) {
        item.style.cursor = 'pointer';
        item.addEventListener('click', () => selectColor(color));
      } else {
        item.style.cursor = 'default';
      }
      
      fragment.appendChild(item);
    });
    
    grid.appendChild(fragment);
  }
  
  function renderPagination() {
    if (filteredColors.length === 0) {
      paginationEl.innerHTML = '';
      return;
    }
    
    const totalPages = Math.ceil(filteredColors.length / ITEMS_PER_PAGE);
    
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }
    
    let html = '';
    
    // Previous button
    html += `<button ${currentPage === 1 ? 'disabled' : ''} onclick="changePage(${currentPage - 1})">← Previous</button>`;
    
    // Page numbers (show current, prev, next, first, last)
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    
    pages.forEach(page => {
      if (page === '...') {
        html += `<span class="bm-pagination-info">...</span>`;
      } else {
        html += `<button class="${page === currentPage ? 'active' : ''}" onclick="changePage(${page})">${page}</button>`;
      }
    });
    
    // Next button
    html += `<button ${currentPage === totalPages ? 'disabled' : ''} onclick="changePage(${currentPage + 1})">Next →</button>`;
    
    paginationEl.innerHTML = html;
  }
  
  window.changePage = function(page) {
    currentPage = page;
    renderPage();
    renderPagination();
    // Scroll to top of grid
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  function selectColor(color) {
    selectedSwatch.style.backgroundColor = color.hex;
    selectedName.textContent = `${color.name} (${color.code})`;
    hiddenInput.value = `${color.name} (${color.code})`;
    modal.classList.remove('open');
    
    // Remove error state when color is selected
    const container = document.querySelector('.benjamin-moore-color-picker-container');
    if (container) {
      container.classList.remove('color-required-error');
        
      // Update Shop Pay buttons state (checks both color and checkbox)
      updateShopPayState();
    }
    
    // Trigger change event if needed for other scripts
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

    // Update Shop Pay / Accelerated Checkout button state based on BOTH color and checkbox
  function updateShopPayState() {
    const acceleratedCheckout = document.querySelector('.accelerated-checkout-block');
    const shopifyPaymentContainer = document.querySelector('.shopify-payment-button');
    
    // Check if color is selected
    const pickerContainer = document.querySelector('.benjamin-moore-color-picker-container');
    let colorValid = true;
    if (pickerContainer) {
      const style = window.getComputedStyle(pickerContainer);
      const isVisible = style.display !== 'none';
      const hiddenInputVal = document.getElementById('bm-paint-color-input');
      const hasColor = hiddenInputVal && hiddenInputVal.value && hiddenInputVal.value.trim() !== '';
      colorValid = !isVisible || hasColor; // Valid if picker is hidden OR color is selected
    }
    
    // Check if checkbox is checked (find checkbox inside accelerated checkout block)
    const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
    const checkboxValid = !agreeCheckbox || agreeCheckbox.checked; // Valid if no checkbox OR it's checked
    
    // Both must be valid to enable
    const enabled = colorValid && checkboxValid;
    
    // Only disable the payment button, NOT the entire block (which includes the checkbox)
    if (shopifyPaymentContainer) {
      if (enabled) {
        shopifyPaymentContainer.classList.remove('disabled');
        shopifyPaymentContainer.style.pointerEvents = '';
        shopifyPaymentContainer.style.opacity = '';
      } else {
        shopifyPaymentContainer.classList.add('disabled');
        shopifyPaymentContainer.style.pointerEvents = 'none';
        shopifyPaymentContainer.style.opacity = '0.5';
      }
    }
  }

  // Filtering
  function filterColors() {
    const searchTerm = searchInput.value.toLowerCase();
    
    let filtered = allColors.filter(color => {
      const matchesSearch = color.name.toLowerCase().includes(searchTerm) || 
                            color.code.toLowerCase().includes(searchTerm);
      const matchesFamily = currentFamily === '' || color.family === currentFamily;
      
      // Series filter (only applies to color families, not collections)
      let matchesSeries = true;
      if (currentSeries !== '') {
        const colorSeries = getColorSeries(color.code);
        matchesSeries = colorSeries === currentSeries;
      }
      
      return matchesSearch && matchesFamily && matchesSeries;
    });
    
    // Sort by color code (alphanumeric A-Z, 0-9)
    filtered.sort((a, b) => {
      const codeA = (a.code || '').toUpperCase();
      const codeB = (b.code || '').toUpperCase();
      return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
    });
    
    console.log(`Filtered to ${filtered.length} colors (family: ${currentFamily || 'All'}, search: "${searchTerm}")`);
    
    // Update color count
    if (colorCountEl) {
      colorCountEl.textContent = `Found ${filtered.length} color${filtered.length !== 1 ? 's' : ''}`;
    }
    
    renderColors(filtered);
  }

  // Debounce search
  let timeout = null;
  searchInput.addEventListener('input', function() {
    clearTimeout(timeout);
    timeout = setTimeout(filterColors, 300);
  });

  function renderFamilyButtons() {
    familyButtonsContainer.innerHTML = '';
    
    // Count colors per family
    const familyCount = {};
    allColors.forEach(color => {
      if (color.family) {
        familyCount[color.family] = (familyCount[color.family] || 0) + 1;
      }
    });
    
    // Define which families are "color" families (based on familyColors object)
    const colorFamilyNames = Object.keys(familyColors);
    
    // Separate families into colors and collections
    const colorFamilies = [];
    const collectionFamilies = [];
    
    families.forEach(family => {
      if (colorFamilyNames.includes(family)) {
        colorFamilies.push(family);
      } else {
        collectionFamilies.push(family);
      }
    });
    
    // Sort each group by count (most to least)
    colorFamilies.sort((a, b) => (familyCount[b] || 0) - (familyCount[a] || 0));
    collectionFamilies.sort((a, b) => (familyCount[b] || 0) - (familyCount[a] || 0));
    
    // Check if current family is a color family (to show series filter)
    const isColorFamilySelected = currentFamily === '' || colorFamilyNames.includes(currentFamily);
    
    // Create Series filter row (only show when viewing color families)
    if (isColorFamilySelected) {
      const seriesRow = document.createElement('div');
      seriesRow.className = 'bm-family-row bm-family-row--series';
      
      // All Series button
      const allSeriesBtn = document.createElement('button');
      allSeriesBtn.className = 'bm-series-btn' + (currentSeries === '' ? ' active' : '');
      allSeriesBtn.textContent = 'All Series';
      allSeriesBtn.dataset.series = '';
      allSeriesBtn.addEventListener('click', () => selectSeries(''));
      seriesRow.appendChild(allSeriesBtn);
      
      // Colour Preview button
      const previewBtn = document.createElement('button');
      previewBtn.className = 'bm-series-btn' + (currentSeries === 'preview' ? ' active' : '');
      previewBtn.textContent = 'Colour Preview';
      previewBtn.dataset.series = 'preview';
      previewBtn.addEventListener('click', () => selectSeries('preview'));
      seriesRow.appendChild(previewBtn);
      
      // Classics button
      const classicsBtn = document.createElement('button');
      classicsBtn.className = 'bm-series-btn' + (currentSeries === 'classics' ? ' active' : '');
      classicsBtn.textContent = 'Classics';
      classicsBtn.dataset.series = 'classics';
      classicsBtn.addEventListener('click', () => selectSeries('classics'));
      seriesRow.appendChild(classicsBtn);
      
      familyButtonsContainer.appendChild(seriesRow);
    }
    
    // Create row 1 container (All button + Color families)
    const row1 = document.createElement('div');
    row1.className = 'bm-family-row bm-family-row--colors';
    
    // Add "All" button to first row
    const allBtn = document.createElement('button');
    allBtn.className = 'bm-family-btn' + (currentFamily === '' ? ' active' : '');
    allBtn.textContent = 'All';
    allBtn.style.backgroundColor = '#e5e7eb';
    allBtn.style.color = '#000000';
    allBtn.dataset.family = '';
    allBtn.addEventListener('click', () => selectFamily(''));
    row1.appendChild(allBtn);

    // Add color family buttons to first row
    colorFamilies.forEach(family => {
      const btn = document.createElement('button');
      btn.className = 'bm-family-btn' + (currentFamily === family ? ' active' : '');
      const colorBg = familyColors[family] || '#9ca3af';
      const textColor = getContrastColor(colorBg);
      btn.textContent = family;
      btn.style.backgroundColor = colorBg;
      btn.style.color = textColor;
      btn.dataset.family = family;
      btn.addEventListener('click', () => selectFamily(family));
      row1.appendChild(btn);
    });
    
    familyButtonsContainer.appendChild(row1);
    
    // Create row 2 container (Collection families) - only if there are collections
    if (collectionFamilies.length > 0) {
      const row2 = document.createElement('div');
      row2.className = 'bm-family-row bm-family-row--collections';
      
      collectionFamilies.forEach(family => {
        const btn = document.createElement('button');
        btn.className = 'bm-family-btn bm-family-btn--collection' + (currentFamily === family ? ' active' : '');
        btn.textContent = family;
        btn.style.backgroundColor = '#6b7280'; // Default gray for collections
        btn.style.color = '#ffffff';
        btn.dataset.family = family;
        btn.addEventListener('click', () => selectFamily(family));
        row2.appendChild(btn);
      });
      
      familyButtonsContainer.appendChild(row2);
    }
  }
  
  function selectSeries(series) {
    currentSeries = series;
    currentPage = 1;
    
    // Re-render buttons to update active state
    renderFamilyButtons();
    filterColors();
  }

  function selectFamily(family) {
    currentFamily = family;
    currentPage = 1;
    
    // Check if selected family is a collection (not a color family)
    const colorFamilyNames = Object.keys(familyColors);
    const isCollection = family !== '' && !colorFamilyNames.includes(family);
    
    // Clear series filter when selecting a collection
    if (isCollection) {
      currentSeries = '';
    }
    
    // Re-render buttons to update active states and show/hide series row
    renderFamilyButtons();
    filterColors();
  }

  // Calculate contrast and determine text color
  function getContrastColor(hexColor) {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    
    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black for light colors, white for dark colors
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  function renderColors(colors) {
    filteredColors = colors;
    currentPage = 1; // Reset to first page
    
    renderPage();
    renderPagination();
  }
  
  function renderPage() {
    grid.innerHTML = '';
    
    // Update color count
    if (colorCountEl) {
      colorCountEl.textContent = `Found ${filteredColors.length} color${filteredColors.length !== 1 ? 's' : ''}`;
    }
    
    if (filteredColors.length === 0) {
      grid.innerHTML = '<div class="bm-loading">No colors found matching your criteria.</div>';
      paginationEl.innerHTML = '';
      return;
    }
    
    // Calculate pagination
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, filteredColors.length);
    const pageColors = filteredColors.slice(startIndex, endIndex);
    
    const fragment = document.createDocumentFragment();

    pageColors.forEach(color => {
      const item = document.createElement('div');
      item.className = 'bm-color-item';
      item.dataset.name = color.name;
      item.dataset.code = color.code;
      item.dataset.hex = color.hex;
      
      const textColor = getContrastColor(color.hex);
      item.innerHTML = `
        <div class="bm-color-preview" style="background-color: ${color.hex}; color: ${textColor};">
          <div class="bm-color-info">
            <span class="bm-color-code">${color.code}</span>
            <span class="bm-color-name">${color.name}</span>
          </div>
        </div>
      `;
      
      item.addEventListener('click', () => selectColor(color));
      fragment.appendChild(item);
    });
    
    grid.appendChild(fragment);
  }
  
  function renderPagination() {
    if (filteredColors.length === 0) {
      paginationEl.innerHTML = '';
      return;
    }
    
    const totalPages = Math.ceil(filteredColors.length / ITEMS_PER_PAGE);
    
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }
    
    let html = '';
    
    // Previous button
    html += `<button ${currentPage === 1 ? 'disabled' : ''} onclick="changePage(${currentPage - 1})">← Previous</button>`;
    
    // Page numbers (show current, prev, next, first, last)
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    
    pages.forEach(page => {
      if (page === '...') {
        html += `<span class="bm-pagination-info">...</span>`;
      } else {
        html += `<button class="${page === currentPage ? 'active' : ''}" onclick="changePage(${page})">${page}</button>`;
      }
    });
    
    // Next button
    html += `<button ${currentPage === totalPages ? 'disabled' : ''} onclick="changePage(${currentPage + 1})">Next →</button>`;
    
    paginationEl.innerHTML = html;
  }
  

  // Initialize
  const pickerContainer = document.querySelector('.benjamin-moore-color-picker-container');
  if (pickerContainer) {
    const isBrowseMode = pickerContainer.dataset.mode === 'browse';
    
    if (isBrowseMode) {
      console.log('[BM Picker] Browse Mode enabled - skipping variant listeners');
      // In browse mode, we don't listen for variants
    } else {
      // Check if product has color variant
      if (pickerContainer.dataset.hasColorVariant === 'true') {
        setupColorVariantListener();
      }
    }
  } else {
    // Retry once in case of slow DOM
    setTimeout(() => {
      const retryContainer = document.querySelector('.benjamin-moore-color-picker-container');
      if (retryContainer) {
        const isBrowseMode = retryContainer.dataset.mode === 'browse';
        if (!isBrowseMode && retryContainer.dataset.hasColorVariant === 'true') {
          setupColorVariantListener();
        }
      }
    }, 1000);
  }

  // Validation: Make color selection mandatory
  function validateColorSelection() {
    const pickerContainer = document.querySelector('.benjamin-moore-color-picker-container');
    if (!pickerContainer) return true;
    
    // Check for browse mode
    if (pickerContainer.dataset.mode === 'browse') {
      console.log('[BM Picker Validation] Browse Mode - validation skipped');
      return true;
    }
    
    // Check if picker is visible
    // We rely on the UI state: if it's hidden, the user doesn't need to pick a color
    const style = window.getComputedStyle(pickerContainer);
    if (style.display === 'none') {
      console.log('[BM Picker Validation] Picker is hidden, validation skipped');
      pickerContainer.classList.remove('color-required-error');
      return true;
    }

    // If picker is visible, check if a color is selected
    const hiddenInput = document.getElementById('bm-paint-color-input');
    const colorValue = hiddenInput ? hiddenInput.value : '';
    
    if (!colorValue || colorValue.trim() === '') {
      console.log('[BM Picker Validation] ✗ Picker visible but no color selected');
      
      // Show error state
      pickerContainer.classList.add('color-required-error');
      
      // Scroll to color picker
      pickerContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      return false;
    }
    
    console.log('[BM Picker Validation] ✓ Picker visible and color selected');
    pickerContainer.classList.remove('color-required-error');
    return true;
  }
  
  // Expose validation function globally for product-form.js to use
  window.validateBenjaminMooreColor = validateColorSelection;
  
    // Also intercept Buy Now buttons (Shopify payment buttons)
  function setupBuyNowValidation() {
    // Function to add click interceptor to a button
    function addInterceptor(button) {
      if (button.dataset.bmIntercepted) return; // Already intercepted
      button.dataset.bmIntercepted = 'true';
      
        button.addEventListener('click', function(e) {
        // Check color selection
        if (!validateColorSelection()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('[BM Picker] Color selection is required for Shop Pay - blocked');
          return false;
        }
        
        // Check checkbox (agree condition)
        const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
        if (agreeCheckbox && !agreeCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Show error state on checkbox container
          const checkboxContainer = agreeCheckbox.closest('.newsletter-form__checkbox');
          if (checkboxContainer) {
            checkboxContainer.classList.add('checkbox-required-error');
            checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          
          console.log('[BM Picker] Checkbox agreement is required for Shop Pay - blocked');
          return false;
        }
      }, true);
    }
    
    // Add interceptors to existing buttons
    const shopifyPaymentButtons = document.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button button');
    shopifyPaymentButtons.forEach(addInterceptor);
    
    // Initial state update (checks both color and checkbox)
    updateShopPayState();
    
    // Listen to checkbox changes to update Shop Pay state
    const agreeCheckboxEl = document.querySelector('.accelerated-checkout-block .checkbox__input');
    if (agreeCheckboxEl) {
      agreeCheckboxEl.addEventListener('change', function() {
        updateShopPayState();
      });
    }
    
    // Use MutationObserver to catch dynamically added payment buttons
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is a payment button
            if (node.matches && (node.matches('.shopify-payment-button__button') || node.matches('.shopify-payment-button button'))) {
              addInterceptor(node);
            }
            // Check for payment buttons inside the added node
            const buttons = node.querySelectorAll ? node.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button button') : [];
            buttons.forEach(addInterceptor);
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Also add an overlay click interceptor on the payment button container
    const paymentContainer = document.querySelector('.shopify-payment-button');
        if (paymentContainer) {
      paymentContainer.addEventListener('click', function(e) {
        // Check color selection
        if (!validateColorSelection()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('[BM Picker] Color selection is required - payment container blocked');
          return false;
        }
        
        // Check checkbox (agree condition)
        const agreeCheckbox = document.querySelector('.accelerated-checkout-block .checkbox__input');
        if (agreeCheckbox && !agreeCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Show error state on checkbox container
          const checkboxContainer = agreeCheckbox.closest('.newsletter-form__checkbox');
          if (checkboxContainer) {
            checkboxContainer.classList.add('checkbox-required-error');
            checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          
          console.log('[BM Picker] Checkbox agreement is required - payment container blocked');
          return false;
        }
      }, true);
    }
  }
  
  // Setup validation after custom elements are ready
  function initValidation() {
    setupBuyNowValidation();
  }
  
  // Initialize validation after a short delay and on DOM changes
  setTimeout(initValidation, 500);
  
  // Re-setup validation on dynamic content changes
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      initValidation();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Preload colors on page load for instant modal opening
  loadColors();
});
